import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Spinner, Alert, ProgressBar, Carousel } from 'react-bootstrap';
import { 
  FaExclamationTriangle, FaCheckCircle, FaClipboardCheck,
  FaTshirt, FaGraduationCap, FaClipboardList, FaUsers,
  FaChartLine, FaPaw, FaStar, FaFilePdf
} from 'react-icons/fa';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { useNavigate } from 'react-router-dom';
import './AdminDashboardCards.css';

// Importar imágenes theriam
import leonjoel from '../../../assets/leonjoel.png';
import pezcadojoel from '../../../assets/pezcadojoel.png';
import ratonjoel from '../../../assets/ratonjoel.png';
import centaurojoel from '../../../assets/centaurojoel.png';
import salchichajoel from '../../../assets/salchichajoel.png';

// Normalizar API_URL (remover barra final si existe)
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');

// Data del Theriam Horóscopo
const theriamData = [
  {
    mes: 'Enero - Febrero',
    animal: 'León',
    imagen: leonjoel,
    descripcion: 'El León te llena de valentía y liderazgo',
    mensaje: '🦁 Tu espíritu leonino ruge con fuerza para iniciar el año. La energía del rey de la selva fluye en ti, otorgándote el coraje para enfrentar cualquier desafío. Tu presencia inspira respeto y confianza. Es momento de liderar con determinación, pero recuerda: la verdadera fuerza también reside en la sabiduría.',
    color: '#FF8C00',
    gradiente: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  },
  {
    mes: 'Marzo - Abril',
    animal: 'Centauro',
    imagen: centaurojoel,
    descripcion: 'El Centauro equilibra tu fuerza con tu sabiduría',
    mensaje: '🏹 La dualidad del centauro te envuelve en esta primavera. Mitad bestia, mitad sabio, encuentras el balance perfecto entre la acción decidida y el pensamiento estratégico. Tu naturaleza libre te impulsa a explorar nuevos horizontes mientras tu mente aguda te guía. Este es tu momento de armonizar instinto y razón, de galopar hacia tus metas con propósito.',
    color: '#8B4513',
    gradiente: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
  },
  {
    mes: 'Mayo - Junio',
    animal: 'Pez',
    imagen: pezcadojoel,
    descripcion: 'El Pez te conecta con tu intuición profunda',
    mensaje: '🐟 Como el pez que navega las profundidades del océano, este periodo te invita a explorar las aguas de tu intuición. Tu sensibilidad está en su punto máximo, permitiéndote percibir lo que otros no ven. Fluye con las corrientes de la vida, adaptándote con gracia. La claridad mental llega cuando te sumerges en la reflexión.',
    color: '#00CED1',
    gradiente: 'linear-gradient(135deg, #667eea 0%, #0072ff 100%)'
  },
  {
    mes: 'Julio - Agosto',
    animal: 'Salchicha',
    imagen: salchichajoel,
    descripcion: 'La Salchicha te recuerda disfrutar con alegría',
    mensaje: '🌭 El espíritu de la salchicha trae consigo la esencia de la satisfacción y el disfrute. Este periodo te enseña que la vida también se trata de celebrar los pequeños placeres. Tu carisma se vuelve irresistible y tu capacidad de hacer felices a los demás alcanza su pico. Comparte tu energía positiva, pero también date el permiso de disfrutar sin culpas. ¡El verano es tuyo!',
    color: '#FF6347',
    gradiente: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
  },
  {
    mes: 'Septiembre - Diciembre',
    animal: 'Ratón',
    imagen: ratonjoel,
    descripcion: 'El Ratón te enseña el valor de los pequeños detalles',
    mensaje: '🐭 El astuto ratón te recuerda que las grandes victorias nacen de pequeños pasos. Tu atención al detalle está afinada, y tu capacidad para encontrar soluciones ingeniosas te distingue. Este ciclo favorece la planificación meticulosa y la paciencia. No subestimes tu poder: a veces, ser pequeño significa ser ágil e imparable. Cierra el año con astucia.',
    color: '#A0A0A0',
    gradiente: 'linear-gradient(135deg, #667eea 0%, #434343 100%)'
  }
];

// Componente del Carrusel Theriam
const TheriamCarousel = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <Card className="shadow-lg theriam-card" style={{ 
      background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
      border: 'none',
      borderRadius: '15px',
      overflow: 'hidden'
    }}>
      <Card.Body className="p-0">
        <div className="text-center py-3" style={{ background: 'rgba(0,0,0,0.2)' }}>
          <h5 className="mb-0 text-white d-flex align-items-center justify-content-center">
            <FaPaw className="me-2" style={{ color: '#FFD700' }} />
            Tu Theriam Místico
            <FaStar className="ms-2" style={{ color: '#FFD700' }} />
          </h5>
          <small className="text-white opacity-75">Descubre tu espíritu animal</small>
        </div>
        
        <Carousel 
          activeIndex={index} 
          onSelect={handleSelect}
          interval={5000}
          className="theriam-carousel"
        >
          {theriamData.map((theriam, idx) => (
            <Carousel.Item key={idx}>
              <div style={{
                background: theriam.gradiente,
                padding: '40px 30px',
                minHeight: '550px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
              }}>
                {/* Decoración de estrellas */}
                <div style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  fontSize: '24px',
                  opacity: 0.5
                }}>
                  ✨⭐✨
                </div>
                
                <div className="text-white text-center mb-3" style={{
                  background: 'rgba(0, 0, 0, 0.5)',
                  padding: '15px 30px',
                  borderRadius: '15px',
                  backdropFilter: 'blur(10px)'
                }}>
                  <h2 className="fw-bold mb-2" style={{ 
                    textShadow: '3px 3px 6px rgba(0,0,0,0.7)',
                    fontSize: '36px',
                    color: '#FFFFFF'
                  }}>
                    {theriam.animal}
                  </h2>
                  <p className="mb-0" style={{ 
                    fontSize: '16px',
                    color: '#FFFFFF',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                  }}>
                    {theriam.mes}
                  </p>
                </div>

                <div className="mb-4 theriam-image-container" style={{
                  width: '350px',
                  height: '350px',
                  borderRadius: '15px',
                  overflow: 'hidden',
                  border: '6px solid rgba(255,255,255,0.6)',
                  boxShadow: '0 12px 40px rgba(0,0,0,0.5)',
                  background: 'white',
                  transition: 'transform 0.3s ease'
                }}>
                  <img 
                    src={theriam.imagen} 
                    alt={theriam.animal}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                  />
                </div>

                <div className="text-white text-center px-3" style={{ maxWidth: '700px' }}>
                  <p className="fw-bold mb-3" style={{ 
                    fontSize: '22px', 
                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
                    background: 'rgba(0, 0, 0, 0.4)',
                    padding: '12px 20px',
                    borderRadius: '10px',
                    color: '#FFFFFF'
                  }}>
                    {theriam.descripcion}
                  </p>
                  <p style={{ 
                    fontSize: '15px', 
                    lineHeight: '1.7',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
                    background: 'rgba(0,0,0,0.4)',
                    padding: '20px',
                    borderRadius: '12px',
                    color: '#FFFFFF'
                  }}>
                    {theriam.mensaje}
                  </p>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </Card.Body>
    </Card>
  );
};

// Helper para obtener headers de auth
const getAuthHeaders = () => {
  const storedUser = localStorage.getItem('user');
  const user = storedUser ? JSON.parse(storedUser) : null;
  const token = localStorage.getItem('token');
  
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
    'x-user-id': String(user?.id || user?.Legajo || user?.CdEmpleado || '1'),
    'x-user-role': String(user?.IdRol || user?.tipoUsuario || '1')
  };
};

const AdminDashboardCards = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Estados para cada sección
  const [reclamosStats, setReclamosStats] = useState({ pendientes: 0, resueltos: 0, validados: 0 });
  const [tallesStats, setTallesStats] = useState({ cargados: 0, pendientes: 0 });
  const [capacitacionesCount, setCapacitacionesCount] = useState(0);
  const [colaboradoresCount, setColaboradoresCount] = useState(0);
  const [diagramasCount, setDiagramasCount] = useState(0);
  
  // Obtener legajo del usuario actual
  const storedUser = localStorage.getItem('user');
  const user = storedUser ? JSON.parse(storedUser) : null;
  const userLegajo = user?.CdUsuario || user?.Legajo || user?.CdEmpleado || user?.id || null;
  const showTheriam = userLegajo === 43 || userLegajo === '43' || String(userLegajo) === '43';
  
  // Obtener nivel de admin del usuario (AdminLevel 1, 2 o 3)
  const adminLevel = Number(user?.AdminLevel) || 1;
  
  console.log('🎯 Theriam Debug - Legajo:', userLegajo, 'Tipo:', typeof userLegajo, 'Mostrar:', showTheriam);
  
  const RECLAMOS_COLORS = ['#FFC107', '#28A745', '#17A2B8'];

  // Refrescar información del usuario al cargar
  useEffect(() => {
    const refreshUserInfo = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await fetch(`${API_URL}/api/auth/refresh-user`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const result = await response.json();
          if (result.success && result.user) {
            // Actualizar localStorage con la info completa del usuario
            localStorage.setItem('user', JSON.stringify(result.user));
            console.log('✅ Usuario actualizado:', result.user);
          }
        }
      } catch (err) {
        console.error('⚠️ Error al refrescar usuario:', err);
      }
    };

    refreshUserInfo();
  }, []);

  useEffect(() => {
    const cargarDashboardStats = async () => {
      try {
        setLoading(true);
        
        const startTime = performance.now();
        console.log('⚡ Fetching optimized dashboard stats...');
        
        // ⚡ UNA SOLA LLAMADA al endpoint optimizado
        const response = await fetch(`${API_URL}/api/stats/dashboard`, {
          headers: getAuthHeaders()
        });
        
        const result = await response.json();
        const elapsed = performance.now() - startTime;
        
        if (result.success && result.data) {
          setReclamosStats({
            pendientes: result.data.reclamos.pendientes,
            resueltos: result.data.reclamos.resueltos,
            validados: result.data.reclamos.validados
          });
          setTallesStats({
            cargados: result.data.talles.cargados,
            pendientes: result.data.talles.pendientes
          });
          setCapacitacionesCount(result.data.capacitaciones.categorias);
          setColaboradoresCount(result.data.empleados.total);          setDiagramasCount(result.data.diagramas.total);          
          console.log(`✅ Dashboard loaded in ${elapsed.toFixed(0)}ms (backend: ${result.meta.queryTimeMs}ms)`);
        } else {
          throw new Error(result.error || 'Error en la respuesta del servidor');
        }
      } catch (err) {
        console.error('❌ Error loading dashboard:', err);
        setError(err.message || 'Error al cargar las estadísticas');
      } finally {
        setLoading(false);
      }
    };

    cargarDashboardStats();
  }, []);

  const reclamosChartData = [
    { name: 'Pendientes', value: reclamosStats.pendientes },
    { name: 'Resueltos', value: reclamosStats.resueltos },
    { name: 'Validados', value: reclamosStats.validados },
  ];

  const totalReclamos = reclamosStats.pendientes + reclamosStats.resueltos + reclamosStats.validados;
  const porcentajeResueltos = totalReclamos > 0 ? Math.round(((reclamosStats.resueltos + reclamosStats.validados) / totalReclamos) * 100) : 0;

  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Cargando dashboard...</p>
      </div>
    );
  }

  if (error) {
    return <Alert variant="danger" className="mt-4">{error}</Alert>;
  }

  return (
    <div className="admin-dashboard-modern">
      {/* Header con Bienvenida */}
      <Row className="mb-4">
        <Col xs={12}>
          <div className="dashboard-header" style={{
            background: 'white',
            borderRadius: '12px',
            padding: '30px',
            border: '1px solid #e0e0e0',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
          }}>
            <h2 className="mb-2" style={{ fontWeight: '600', fontSize: '1.8rem', color: '#2c3e50' }}>
              Panel de Control Administrativo
            </h2>
            <p className="mb-0" style={{ fontSize: '0.95rem', color: '#6c757d' }}>
              Gestión integral del sistema SIBUS
            </p>
          </div>
        </Col>
      </Row>

      {/* Accesos Rápidos - Cards Limpios */}
      <Row className="mb-4 g-3">
        {[ 
          { 
            icon: <FaClipboardList size={28} />, 
            title: 'Reclamos', 
            path: '/administrador/reclamos', 
            count: reclamosStats.pendientes, 
            label: 'pendientes de atención', 
            minAdminLevel: 1,
            iconColor: '#3498db'
          },
          { 
            icon: <FaTshirt size={28} />, 
            title: 'Talles', 
            path: '/administrador/talles', 
            count: tallesStats.cargados, 
            label: 'colaboradores registrados', 
            minAdminLevel: 1,
            iconColor: '#2ecc71'
          },
          { 
            icon: <FaGraduationCap size={28} />, 
            title: 'Capacitaciones', 
            path: '/administrador/resumen-capacitaciones', 
            count: capacitacionesCount, 
            label: 'categorías disponibles', 
            minAdminLevel: 1,
            iconColor: '#9b59b6'
          },
          { 
            icon: <FaUsers size={28} />, 
            title: 'Colaboradores', 
            path: '/administrador/administrar_usuarios', 
            count: colaboradoresCount, 
            label: 'usuarios activos', 
            minAdminLevel: 1,
            iconColor: '#e74c3c'
          },
          { 
            icon: <FaFilePdf size={28} />, 
            title: 'Diagramas', 
            path: '/administrador/admin-diagramas', 
            count: diagramasCount, 
            label: 'documentos disponibles', 
            minAdminLevel: 2,
            iconColor: '#f39c12'
          },
        ]
        .filter(item => item.minAdminLevel <= adminLevel)
        .map((item, idx) => (
          <Col key={idx} lg={item.minAdminLevel === 2 ? 12 : 6} xl={item.minAdminLevel === 2 ? 6 : 3}>
            <Card 
              className="h-100 modern-stats-card" 
              style={{ 
                cursor: 'pointer',
                background: 'white',
                border: '1px solid #e0e0e0',
                borderRadius: '12px',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
              }}
              onClick={() => navigate(item.path)}
            >
              <Card.Body className="p-4">
                <div className="d-flex align-items-start mb-3">
                  <div 
                    className="icon-box" 
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '10px',
                      background: `${item.iconColor}15`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: item.iconColor
                    }}
                  >
                    {item.icon}
                  </div>
                </div>
                
                <h6 className="mb-2 text-uppercase" style={{ 
                  fontSize: '0.75rem', 
                  fontWeight: '600',
                  letterSpacing: '0.5px',
                  color: '#6c757d'
                }}>
                  {item.title}
                </h6>
                <h1 className="mb-2 fw-bold" style={{ 
                  fontSize: '2.5rem',
                  lineHeight: '1',
                  color: '#2c3e50'
                }}>
                  {item.count}
                </h1>
                <p className="mb-0" style={{ 
                  fontSize: '0.85rem',
                  color: '#6c757d'
                }}>
                  {item.label}
                </p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Theriam Horóscopo - Solo para usuario 43 */}
      {showTheriam && (
        <Row className="mb-5">
          <Col lg={12}>
            <TheriamCarousel />
          </Col>
        </Row>
      )}

      {/* Sección de Análisis de Reclamos */}
      <Row className="mb-4 g-3">
        <Col lg={12}>
          <Card style={{
            border: '1px solid #e0e0e0',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
            background: 'white'
          }}>
            <Card.Body className="p-4">
              <div className="d-flex align-items-center mb-4" style={{
                paddingBottom: '15px',
                borderBottom: '1px solid #e0e0e0'
              }}>
                <div 
                  style={{
                    width: '45px',
                    height: '45px',
                    borderRadius: '10px',
                    background: '#3498db15',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px',
                    color: '#3498db'
                  }}
                >
                  <FaChartLine size={22} />
                </div>
                <div>
                  <h5 className="mb-0 fw-semibold" style={{ color: '#2c3e50' }}>Análisis de Reclamos</h5>
                  <small className="text-muted">Resumen del estado de gestión</small>
                </div>
              </div>

              <Row className="g-3 mb-4">
                {[
                  { 
                    key: 'pendientes', 
                    icon: <FaExclamationTriangle size={20} />, 
                    color: '#f39c12', 
                    label: 'Pendientes'
                  },
                  { 
                    key: 'resueltos', 
                    icon: <FaCheckCircle size={20} />, 
                    color: '#2ecc71', 
                    label: 'Resueltos'
                  },
                  { 
                    key: 'validados', 
                    icon: <FaClipboardCheck size={20} />, 
                    color: '#3498db', 
                    label: 'Validados'
                  },
                ].map((item, idx) => (
                  <Col key={idx} md={4}>
                    <div 
                      className="stat-card-mini" 
                      style={{
                        background: '#f8f9fa',
                        padding: '20px',
                        borderRadius: '10px',
                        border: '1px solid #e0e0e0',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: '600', letterSpacing: '0.5px' }}>
                            {item.label}
                          </small>
                          <h2 className="mb-0 fw-bold mt-1" style={{ color: item.color, fontSize: '2rem' }}>
                            {reclamosStats[item.key]}
                          </h2>
                        </div>
                        <div style={{
                          width: '45px',
                          height: '45px',
                          borderRadius: '10px',
                          background: `${item.color}15`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: item.color
                        }}>
                          {item.icon}
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}

              </Row>

              <div style={{
                background: '#f8f9fa',
                padding: '20px',
                borderRadius: '10px',
                marginBottom: '20px',
                border: '1px solid #e0e0e0'
              }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span className="fw-semibold" style={{ fontSize: '0.95rem', color: '#2c3e50' }}>Tasa de resolución</span>
                  <span className="fw-bold" style={{ fontSize: '1.3rem', color: '#2ecc71' }}>{porcentajeResueltos}%</span>
                </div>
                <ProgressBar style={{ height: '12px', borderRadius: '6px', background: '#e9ecef' }}>
                  <ProgressBar 
                    now={(reclamosStats.resueltos / Math.max(totalReclamos, 1)) * 100} 
                    key={1}
                    style={{ background: '#2ecc71' }}
                  />
                  <ProgressBar 
                    now={(reclamosStats.validados / Math.max(totalReclamos, 1)) * 100} 
                    key={2}
                    style={{ background: '#3498db' }}
                  />
                </ProgressBar>
              </div>

              {reclamosChartData.some(item => item.value > 0) && (
                <div style={{ 
                  height: '230px',
                  background: '#f8f9fa',
                  borderRadius: '10px',
                  padding: '15px',
                  border: '1px solid #e0e0e0'
                }}>
                  <h6 className="text-center mb-3" style={{ fontSize: '0.9rem', fontWeight: '600', color: '#2c3e50' }}>Distribución de Estados</h6>
                  <ResponsiveContainer width="100%" height="85%">
                    <PieChart>
                      <Pie
                        data={reclamosChartData}
                        cx="50%"
                        cy="50%"
                        innerRadius={55}
                        outerRadius={80}
                        fill="#8884d8"
                        dataKey="value"
                        label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                      >
                        {reclamosChartData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={RECLAMOS_COLORS[index % RECLAMOS_COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Sección Resumen Final */}
      <Row className="g-3">
        <Col lg={12}>
          <Card style={{
            border: '1px solid #e0e0e0',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
            background: 'white'
          }}>
            <Card.Body className="p-4">
              <div className="d-flex align-items-center mb-4" style={{
                paddingBottom: '15px',
                borderBottom: '1px solid #e0e0e0'
              }}>
                <div 
                  style={{
                    width: '45px',
                    height: '45px',
                    borderRadius: '10px',
                    background: '#3498db15',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px',
                    color: '#3498db'
                  }}
                >
                  <FaChartLine size={22} />
                </div>
                <div>
                  <h5 className="mb-0 fw-semibold" style={{ color: '#2c3e50' }}>Resumen General</h5>
                  <small className="text-muted">Métricas del sistema</small>
                </div>
              </div>
              
              <Row className="g-3">
                {[
                  { 
                    label: 'Total Reclamos', 
                    value: totalReclamos, 
                    icon: <FaClipboardList size={18} />,
                    color: '#3498db'
                  },
                  { 
                    label: 'Pendientes', 
                    value: reclamosStats.pendientes, 
                    icon: <FaExclamationTriangle size={18} />,
                    color: '#f39c12'
                  },
                  { 
                    label: 'Resueltos', 
                    value: reclamosStats.resueltos, 
                    icon: <FaCheckCircle size={18} />,
                    color: '#2ecc71'
                  },
                  { 
                    label: 'Talles Cargados', 
                    value: tallesStats.cargados, 
                    icon: <FaTshirt size={18} />,
                    color: '#9b59b6'
                  }
                ].map((item, idx) => (
                  <Col key={idx} md={6} lg={3}>
                    <div 
                      style={{
                        background: '#f8f9fa',
                        padding: '20px',
                        borderRadius: '10px',
                        border: '1px solid #e0e0e0',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: '600', letterSpacing: '0.5px' }}>
                          {item.label}
                        </small>
                        <div 
                          style={{
                            width: '35px',
                            height: '35px',
                            borderRadius: '8px',
                            background: `${item.color}15`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: item.color
                          }}
                        >
                          {item.icon}
                        </div>
                      </div>
                      <h3 className="mb-0 fw-bold" style={{ color: item.color, fontSize: '2rem' }}>
                        {item.value}
                      </h3>
                    </div>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AdminDashboardCards;